import { EntityRequestBiztrip } from "../../entity/EntityRequestBiztrip";

export class DtoRequestBiztripsPutRes extends EntityRequestBiztrip {}
